(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativeUpdateStatusAssessByInitiativeAssessmentController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'govProcess', 'initAssessmentsByAssessor', 'assessmentByInitiative', 'fiscalYearQuarterKeys'];

    function Controller($scope, $state, topBarService, govProcess, initAssessmentsByAssessor, assessmentByInitiative, fiscalYearQuarterKeys) {

        if (redirectToDeliverables(assessmentByInitiative)) {
            $state.go('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeDeliverables', { replace: true })
        }

        topBarService.setTitleAndIcon('Business Planning', 'fa fa-compass');
        $scope.govProcess = govProcess;

        $scope.ctrlCtxt = {};
        $scope.ctrlCtxt.fiscalYearQuarterKeys = fiscalYearQuarterKeys;

        $scope.initAssessmentsByAssessor = initAssessmentsByAssessor;
        $scope.planInitiativeAssessment  = assessmentByInitiative.PlanInitiativeAssessment;
        $scope.planInitiative            = assessmentByInitiative.PlanInitiative;
        $scope.initiativesList           = assessmentByInitiative.InitiativesList;

        // $scope.canEdit = false;
        // if ($scope.assessmentByInitiative && $scope.assessmentByInitiative.PlanInitiative) {
        //     $scope.canEdit = $scope.assessmentByInitiative.PlanInitiative.IsOwner || $scope.assessmentByInitiative.PlanInitiative.IsOwnerDelegate;
        // }

        function redirectToDeliverables(assessmentByInitiative) {
            if (_.isUndefined(assessmentByInitiative.PlanInitiativeAssessment)) return false;

            return !assessmentByInitiative.PlanInitiativeAssessment.AreAllDeliverablesAssessed;
        }
    }
})();